// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'document-xls';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.438 15.905a1.063 1.063 0 0 1-1.063 1.062H2.625a1.063 1.063 0 0 1-1.062-1.062V2.092A1.062 1.062 0 0 1 2.625 1.03H13.25c.277 0 .543.109.742.302l2.125 2.042a1.062 1.062 0 0 1 .32.76z' />
    <path d='M5.635 6.115h6.73v6.375h-6.73zm0 2.125h6.73m-6.73 2.125h6.73M9 6.115v6.375' />
  </g>
);

export const viewBox = '0 0 18 18';
